module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "final-projects"
  }, [(_vm.terms) ? _c('ul', {
    staticClass: "terms"
  }, _vm._l((_vm.terms), function(term) {
    return _c('li', [_c('div', {
      staticClass: "toggle",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectedTerm === term.id ? _vm.selectedTerm = null : _vm.selectedTerm = term.id
        }
      }
    }, [(_vm.selectedTerm === term.id) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    }), _vm._v("\n                " + _vm._s(term.name) + " (" + _vm._s(term.studentCount) + " Students)\n                "), _c('span', {
      staticStyle: {
        "color": "#C33B3A"
      }
    }, [_vm._v(_vm._s(term.projects ? " " + term.projects + " project(s) need feedback" : ""))]), _vm._v(" "), (term.projects && term.notClouded) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#3AC384"
      }
    }, [_vm._v(_vm._s(term.notClouded ? " " + term.notClouded + " passed project(s) not in cloudinary" : ""))])]), _vm._v(" "), (_vm.selectedTerm == term.id) ? _c('div', [_c('button', {
      staticClass: "btn btn-success toggle-finished",
      on: {
        "click": function($event) {
          _vm.showFinished = !_vm.showFinished
        }
      }
    }, [_vm._v("Show "), (_vm.showFinished) ? _c('span', [_vm._v("All")]) : _c('span', [_vm._v("Finished")])]), _vm._v(" "), _vm._l((term.students), function(students, path) {
      return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.pathName(path)))]), _vm._v(" "), _c('ul', {
        staticClass: "students"
      }, _vm._l((students), function(student) {
        return _c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isInFilter(student)),
            expression: "isInFilter(student)"
          }],
          class: {
            'finished': student.finished
          }
        }, [_c('h3', [_c('router-link', {
          attrs: {
            "to": {
              name: 'student',
              params: {
                studentId: student.populiId
              },
              query: {
                userId: student.id,
                open: 'projects',
                term: term.id,
                final_project: 'true'
              }
            },
            "target": "_blank"
          }
        }, [_vm._v("\n                                    " + _vm._s(student.firstName) + " " + _vm._s(student.lastName) + "\n                                    ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "status",
          class: student.projectStatus
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'student',
              params: {
                studentId: student.populiId
              },
              query: {
                userId: student.id,
                open: 'projects',
                term: term.id,
                final_project: 'true'
              }
            },
            "target": "_blank"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("deslugify")(student.projectStatus)) + "\n                                    ")])], 1)])
      }))])
    })], 2) : _vm._e()])
  })) : _c('div', [_c('loader')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15da0414!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/FinalProjects.vue
// module id = 1982
// module chunks = 2